import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/BankBaby/HomeView.vue'
// import WebView from '../views/WebView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
    // component: WebView
  },
  {
    path:'/login',
    name:'login',
    component: ()=> import("@/views/BankBaby/LoginView.vue"),
  },
  {
    path:'/SignUp',
    name:'signUp',
    component: ()=> import("@/views/BankBaby/SignUpView.vue"),
  },
  {
    path:'/SetupBank',
    name:'setupBank',
    component: ()=> import("@/views/BankBaby/SetupBankView.vue"),
  },
  {
    path:'/Parents',
    name:'parents',
    component: ()=> import("@/views/BankBaby/ParentsView.vue"),
  },
  {
    path:'/ExpectedDate',
    name:'expectedDate',
    component: ()=> import("@/views/BankBaby/ExpectedDateView.vue"),
  },
  {
    path:'/InvitePeople',
    name:'invitePeople',
    component: ()=> import("@/views/BankBaby/InvitePeopleView.vue"),
  },
  {
    path:'/BabyBank/:mom/:dad/:ed/:uuid',
    component: ()=> import("@/views/BankBaby/BabyBank.vue"),
  },
  {
    path:'/BankStarted',
    name:'bankStarted',
    component: ()=> import("@/views/BankBaby/BankStartedView.vue"),
  },
  {
    path:'/OpenBanks',
    name:'openBanks',
    component: ()=> import("@/views/BankBaby/OpenBankView.vue"),
  },
  {
    path:'/BankDetails',
    name:'bankDetails',
    component: ()=> import("@/views/BankBaby/BankDetailsView.vue"),
  },
  {
    path:'/Giving',
    name:'giving',
    component: ()=> import("@/views/BankBaby/GivingView.vue"),
  },
  {
    path:'/GivingThanks',
    name:'givingThanks',
    component: ()=> import("@/views/BankBaby/GivingThanksView.vue"),
  },
  {
    path:'/BankStatus',
    name:'bankStatus',
    component: ()=> import("@/views/BankBaby/BankStatusView.vue"),
  },
  {
    path:'/BankStats',
    name:'bankStats',
    component: ()=> import("@/views/BankBaby/BankStatsView.vue"),
  },
  {
    path:'/BankChats',
    name:'bankChats',
    component: ()=> import("@/views/BankBaby/BankChatView.vue"),
  },
  {
    path:'/ChangeVote',
    name:'changeVote',
    component: ()=> import("@/views/BankBaby/ChangeVoteView.vue"),
  },
  {
    path:'/AdminExpectedDate',
    name:'adminExpectedDate',
    component: ()=> import("@/views/BankBaby/AdminExpectedDateView.vue"),
  },
  {
    path:'/AdminGivingResults',
    name:'adminGivingResults',
    component: ()=> import("@/views/BankBaby/AdminGivingResultsView.vue"),
  },
  {
    path:'/UpdateInfo',
    name:'UpdateInfo',
    component: ()=> import("@/views/BankBaby/UpdateInfoView.vue"),
  },
  // {
  //   path:'/BankChats',
  //   name:'bankChats',
  //   component: ()=> import("@/views/BankBaby/BankChatView.vue"),
  // },
  {
    path:'/BankEnd',
    name:'bankEnd',
    component: ()=> import("@/views/BankBaby/BankEndedView.vue"),
  },
  
  //////////////////////////////////////////////////////

  //////////////////////////////////////////////////////
  {
    path: "/example/:id(\\d+)?", // regular expretions *, +, ?
    component: ()=> import("@/views/LoginView.vue"),
  },
  
  {
    path:'/:pathMatch(.*)*',
    name:'NotFound',
    component: ()=> import('@/views/NotFound.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
